import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { TrustBar } from "@/components/site/TrustBar";
import { Services } from "@/components/site/Services";
import { Manifesto } from "@/components/site/Manifesto";
import { About } from "@/components/site/About";
import { ProductIndependence } from "@/components/site/ProductIndependence";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <Services />
        <Manifesto />
        <About />
        <ProductIndependence />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
